<template>
  <div id="app">
    <Navbar></Navbar>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
export default {
  name: "App",
  components: {
    Navbar: Header,
    Footer: Footer
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue